import * as types from "../constants/ActionTypes";
const initialState = {
  qtd: 0,
  list: [],
  totalOfUnreadedMessages: 0,
};

const listQuarentineQueue = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_QUARENTINE_QUEUE:
      let hasThisCallInTheQueue = false;
      let updatedTotalOfUnreadedMessagesInAdd = state.totalOfUnreadedMessages;
      const newList = state.list.map((call) => {
        const hasThisCallInTheList =
          parseInt(call.cdrId) === parseInt(action.cdrId) &&
          parseInt(call.idAtendimento) === parseInt(action.idAtendimento);
        if (hasThisCallInTheList) {
          hasThisCallInTheQueue = true;
          updatedTotalOfUnreadedMessagesInAdd =
            updatedTotalOfUnreadedMessagesInAdd -
            call.unreadMessages +
            call.action.unreadMessages
              ? action.unreadMessages
              : 0;
          return {
            standbyId: action.standbyId,
            cdrId: action.cdrId,
            idAtendimento: action.idAtendimento,
            contactName: action.contactName,
            scoreValue: action.scoreValue,
            scoreClass: action.scoreClass,
            dateTime: action.dateTime,
            phoneNumber: action.phoneNumber,
            midiaId: action.midiaId,
            contactId: action.contactId,
            unreadMessages: action.unreadMessages ? action.unreadMessages : 0,
          };
        }
        return call;
      });
      if (!hasThisCallInTheQueue) {
        return {
          qtd: state.qtd + 1,
          list: [
            {
              standbyId: action.standbyId,
              cdrId: action.cdrId,
              idAtendimento: action.idAtendimento,
              contactName: action.contactName,
              scoreValue: action.scoreValue,
              scoreClass: action.scoreClass,
              dateTime: action.dateTime,
              phoneNumber: action.phoneNumber,
              midiaId: action.midiaId,
              contactId: action.contactId,
              unreadMessages: action.unreadMessages ? action.unreadMessages : 0,
            },
            ...state.list,
          ],
          totalOfUnreadedMessages:
            state.totalOfUnreadedMessages + action.unreadMessages
              ? action.unreadMessages
              : 0,
        };
      }
      return {
        qtd: state.qtd,
        list: newList,
        totalOfUnreadedMessages: updatedTotalOfUnreadedMessagesInAdd,
      };
    case types.REMOVE_QUARENTINE_QUEUE:
      let hasThisCallInTheQueueInRemove = false;
      let updatedTotalOfUnreadedMessagesInRemove =
        state.totalOfUnreadedMessages;

      const filteredList = state.list.filter((call) => {
        const hasThisCallInTheListInRemove =
          parseInt(call.cdrId) === parseInt(action.cdrId) &&
          parseInt(call.idAtendimento) === parseInt(action.idAtendimento);
        if (hasThisCallInTheListInRemove) {
          hasThisCallInTheQueueInRemove = true;
          updatedTotalOfUnreadedMessagesInRemove =
            updatedTotalOfUnreadedMessagesInRemove - call.unreadMessages;
        }
        return !hasThisCallInTheListInRemove;
      });

      if (hasThisCallInTheQueueInRemove) {
        return {
          qtd: state.qtd - 1,
          list: filteredList,
          totalOfUnreadedMessages: updatedTotalOfUnreadedMessagesInRemove,
        };
      }

      return state;
    case types.EDIT_NUMBER_OF_UNREAD_MESSAGES_OF_QUARENTINE_QUEUE:
      const index = state.list.findIndex(
        (item) =>
          item.cdrId === action.cdrId ||
          parseInt(item.cdrId) === parseInt(action.cdrId)
      );

      if (index === -1) return state;

      const editedList = [...state.list];
      const oldNumberOfUnreadedMessages = editedList[index].unreadMessages;
      const newNumberOfUnreadedMessages = action.unreadMessages;
      const updatedTotalOfUnreadedMessages =
        state.totalOfUnreadedMessages -
        oldNumberOfUnreadedMessages +
        newNumberOfUnreadedMessages;

      editedList[index] = {
        ...editedList[index],
        unreadMessages: action.unreadMessages,
      };

      return {
        qtd: state.qtd,
        list: editedList,
        totalOfUnreadedMessages: updatedTotalOfUnreadedMessages,
      };
    case types.ADD_ONE_MORE_UNREADED_MESSAGE_OF_QUARENTINE_QUEUE:
      const indexInAddOne = state.list.findIndex(
        (item) =>
          item.cdrId === action.cdrId ||
          parseInt(item.cdrId) === parseInt(action.cdrId)
      );
      if (indexInAddOne === -1) return state;
      const editedListInAdOne = [...state.list];

      editedListInAdOne[indexInAddOne] = {
        ...editedListInAdOne[indexInAddOne],
        unreadMessages: editedListInAdOne[indexInAddOne].unreadMessages + 1,
      };

      return {
        qtd: state.qtd,
        list: editedListInAdOne,
        totalOfUnreadedMessages: state.totalOfUnreadedMessages + 1,
      };
    case types.CLEAR_QUARENTINE_ALL:
      console.log("INGENIUM_INITIALLOGIN");
      return {
        qtd: 0,
        list: [],
        totalOfUnreadedMessages: 0,
      };
    case types.CHANGE_NUMBER_OF_UNREADED_MESSAGES_OF_AN_ITEM:
      const indexInChangeNumber = state.list.findIndex(
        (item) =>
          item.cdrId === action.cdrId ||
          parseInt(item.cdrId) === parseInt(action.cdrId)
      );
      if (indexInChangeNumber === -1) return state;
      const editedListInChangeNumber = [...state.list];

      editedListInChangeNumber[indexInChangeNumber] = {
        ...editedListInChangeNumber[indexInChangeNumber],
        unreadMessages: action.qtd,
      };
      return {
        qtd: state.qtd,
        list: editedListInChangeNumber,
        totalOfUnreadedMessages:
          state.totalOfUnreadedMessages -
          state.list[indexInChangeNumber].unreadMessages +
          action.qtd,
      };
    default:
      return state;
  }
};

export default listQuarentineQueue;
